import React from "react";
import "./basketballbdayblock.css";
import { Link } from "react-router-dom";
import post from "../../../Assets/Images/BasketBallBday/bday_post.png";

const BasketBallBdayBlock = ({
  image = post,
  name = "Make Your Shootin' School Birthday Party Unforgettable!",
  order = "right",
  buttonText = "Learn More",
  buttonLink = "#",
}) => {
  return (
    <div className={`basketballbdayblock-ss-block-ui ${order}`}>
      {/* Image */}
      <div className="ssb-img">
        {/* <img src={image} alt={name} /> */}
        {/* <img
              src={image}
              title={name}
             
          /> */}

        <iframe
          className="instagram-media instagram-media-rendered"
          src="https://www.instagram.com/reel/CrLtpo3p8qe/embed/?cr=1&v=14"
          allowTransparency={true}
          allowFullScreen={true}
          frameBorder="0"
          scrolling="no"
          style={{
            background: "white",
            maxWidth: "540px",
            width: "calc(100% - 2px)",
            borderRadius: "3px",
            border: "1px solid rgb(219, 219, 219)",
            boxShadow: "none",
            display: "block",
            margin: "0px 0px 12px",
            padding: "0px",
            height: "670px",
          }}
        />
      </div>

      {/* Content */}
      <div className="ssb-cnt">
        <div className="ssb-title">
          <h2 className="text-clip">{name}</h2>
        </div>

        <div className="ssb-desc">
          <ul>
            <li className="text-clip">
              <i className="ri-checkbox-circle-line"></i>Calculate and Customize
              Your Dream Party with Our Birthday Party Calculator!
            </li>
            <li className="text-clip">
              <i className="ri-checkbox-circle-line"></i>Options for Pizza,
              Catered Food, T-shirts, Custom Basketballs, Gift Bags, and More!
            </li>
            <li className="text-clip">
              <i className="ri-checkbox-circle-line"></i>Let Us Help You Plan a
              Memorable Birthday Celebration with Shootin School
            </li>
          </ul>
        </div>

        <div className="ssb-desc">
          <Link to={buttonLink} className="vb-btn">
            <span className="text-clip">{buttonText}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BasketBallBdayBlock;
